import React from 'react'
import './contact.css'
import axios from 'axios';

export const  Contact = () => {
    //const [name, email, message] = useState(0);
    const state = {
        name: '',
        email: '',
        message: ''
      }
      const handleSubmit = (e) => {
        e.preventDefault();
        axios({
          method: "POST",
          url:"http://localhost:3002/send",
          data:  this.state
        }).then((response)=>{
          if (response.data.status === 'success') {
            alert("Message Sent.");
            this.resetForm()
          } else if (response.data.status === 'fail') {
            alert("Message failed to send.")
          }
        })
      }

      const onNameChange = (event) => {
        this.setState({name: event.target.value})
      } 
    
      const onEmailChange = (event) => {
        this.setState({email: event.target.value})
      }
    
      const onMessageChange = (event) => {
        this.setState({message: event.target.value})
      }
    
    return (
        <>
        
        <div className="contact">
           <div className="inner-container">
              
              <form id="contact-form" onSubmit={handleSubmit.bind(this)} method="POST">
          <div className="form-group">
              <label htmlFor="name">Name</label>
              <input placeholder="Your Name........." type="text" className="form-control" id="name" value={state.name} onChange={onNameChange.bind(this)} />
          </div>
          <div className="form-group">
              <label htmlFor="exampleInputEmail1">Email</label>
              <input placeholder="Your Email..........." type="email" className="form-control" id="email" aria-describedby="emailHelp" value={state.email} onChange={onEmailChange.bind(this)} />
          </div>
          <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea placeholder="Your Message......" className="form-control" rows="5" id="message" value={state.message} onChange={onMessageChange.bind(this)} />
          </div>
          <div className="actions">
          <input type="submit" value="Submit" className="button" />
        </div>
        </form>
              
            </div>
           <div className="info"></div>
        </div>
            </>
    )
  }